import Header from "components/Common/Header/Header";
import CourseCertificationBody from "components/CourseComponents/CourseDetails/CourseCertificationComponents/CourseCertificationBody/CourseCertificationBody";
import React, { useEffect } from "react";

const CourseCertification = () => {
  useEffect(() => {
    document.title = "Course Certification";
  }, []);
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="courses" />

      {/* ---------- body section ------------- */}
      <CourseCertificationBody />
    </main>
  );
};

export default CourseCertification;
